export default "__VITE_ASSET__ByDzO6RH__"